import styled from "styled-components";
import { EmbedWrapperProps } from "./Embed.types";

export const EmbedWrapper = styled.div<EmbedWrapperProps>`
	max-width: 100%;

	iframe {
		max-width: 100%;
		aspect-ratio: ${(props) => (props.aspectRatio ? "16/9" : "unset")};
		${(props) => (props.aspectRatio ? `height: auto;` : null)}
	}
`;
